import React from 'react';
import { SceneToken } from '../../../enums/scene-token.enum';
import styles from './close-button.module.scss';

interface CloseButtonProps {
	onClick: (event: React.MouseEvent) => void;
  currentScene: SceneToken;
}

export default function CloseButton({ onClick, currentScene }:CloseButtonProps) {
	return <button className={currentScene == SceneToken.START_PAGE ? styles.startPage : styles.default} onClick={onClick}/>
}